import React, { useCallback } from 'react';
import { Button } from '@readcloud/ui';
import { useStepper } from '../Stepper/Stepper';
import { useFormContext } from 'react-hook-form';
import type { UploadWizardFormData } from './UploadWizardDialog';

type Props = {
  onSubmit: () => void;
  isChecked: boolean
};

export const UploadWizardFooter = (props: Props) => {
  const { nextStep, activeStep, prevStep, isLastStep, initialStep } =
    useStepper();
  const {
    getValues,
    formState: { errors },
    trigger,
  } = useFormContext<UploadWizardFormData>();
  
  const handleNext = useCallback(async () => {
    // Use path notation for nested fields
    let fieldsToValidate: Array<keyof UploadWizardFormData | 'content.type'> =
      [];
    switch (activeStep) {
      case 1:
        fieldsToValidate = ['content'];
        break;
      case 2:
        fieldsToValidate = ['thumbnail'];
        break;
      case 3:
        fieldsToValidate = ['title', 'description', 'printable'];
        break;
      case 4:
        fieldsToValidate = ['clouds'];
        break;
      case 5:
        fieldsToValidate = ['termsAndConditions'];
        break;
      default:
        fieldsToValidate = [];
    }

    const isStepValid = await trigger(fieldsToValidate);
    if (isStepValid) {
      nextStep();
    }
  },[]);

  const handleSubmit = useCallback(async () => {
    // Use path notation for nested fields
    let fieldsToValidate: Array<keyof UploadWizardFormData | 'content.type'> =
      [];

    fieldsToValidate = ['termsAndConditions'];

    const isStepValid = await trigger(fieldsToValidate);
    if (isStepValid) {
      props.onSubmit();
    }
  },[]);

  const values = getValues();

  const getNextDisabledState = () => {
    switch (activeStep) {
      case 1:
        return !values.content?.file && !values.content?.url;
      case 3:
        return !values.title || values.title.trim() === '';
      case 4:
        return !values.clouds || values.clouds.length === 0;
      default:
        return false;
    }
  };

  return (
    <>
      {activeStep > 0 && (
        <div className="rc-flex rc-justify-end rc-gap-2">
          <Button variant="ghost" onClick={prevStep}>
            Back
          </Button>

          {!isLastStep ? (
            <Button
              variant="default"
              onClick={handleNext}
              disabled={getNextDisabledState()}
            >
              Next
            </Button>
          ) : (
            <Button
              variant="default"
              onClick={handleSubmit}
              disabled={!props.isChecked}
            >
              Submit
            </Button>
          )}
        </div>
      )}
    </>
  );
};
